<template>
  <div id="app">
    <router-view />
    <TabBar v-if="showTabBar && hideshow"></TabBar>
  </div>
</template>
<script>
import "normalize.css";
import TabBar from "./components/TabBar";
export default {
  components: {
    TabBar
  },
  data() {
    return {
      showTabBar: false,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hideshow: true //显示或者隐藏footer
    };
  },
  mounted() {
    window.onresize = () => {
      this.showHeight = document.documentElement.clientHeight;
    };
  },
  watch: {
    $route() {
      // console.log(this.$route.name);
      let showTabBarRoute = ["AdApply", "History", "Reimbursement"];
      this.showTabBar = showTabBarRoute.includes(this.$route.name);
      if (!localStorage.getItem("myToken")) {
        this.showTabBar = false;
      }
    },
    showHeight: function() {
      if (this.docmHeight > this.showHeight) {
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
    }
  }
};
</script>
<style>
#app {
  /* padding-bottom: 50px; */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.van-dialog__message {
  font-size: 16px !important;
}
</style>
